import { SectionData, WebsiteData } from '@betterfunnel/types';
import { doc, UpdateData, updateDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../Firebase';
import { updateDynamicPageHasPendingPublishChanges } from './DynamicPagesService';

export type CreatableWebsiteSectionType =
  | 'hero'
  | 'logos'
  | 'cta'
  | 'features'
  | 'testimonials'
  | 'faqs'
  | 'contactUs'
  | 'form'
  | 'calendly'
  | 'footer'
  | 'code'
  | 'textImage'
  | 'showcase'
  | 'categories'
  | 'comparisonList'
  | 'comparisonTopItems'
  | 'trustpilot';

export const createWebsiteSection = async (
  accountId: string,
  dynamicPageId: string,
  variantId: string,
  websiteId: string,
  section: Partial<Omit<SectionData, 'type'>> & {
    type: CreatableWebsiteSectionType;
  },
  prompt?: string,
  params?: Record<string, any>,
): Promise<{ section: SectionData }> => {
  const fn = httpsCallable<unknown, { section: SectionData }>(
    functions,
    'accounts-websites-createWebsiteSection',
  );

  const res = await fn({
    accountId,
    campaignId: dynamicPageId,
    variantId,
    websiteId,
    section,
    params,
    ...(prompt ? { prompt } : {}),
  });

  return res.data;
};

export const publishWebsite = async (
  accountId: string,
  dynamicPageId: string,
  websiteId: string,
): Promise<any> => {
  const fn = httpsCallable(functions, 'accounts-websites-publishWebsite');

  const res = await fn({
    accountId,
    campaignId: dynamicPageId,
    websiteId,
  });

  updateDynamicPageHasPendingPublishChanges(accountId, dynamicPageId, true);

  return res.data;
};

export const updateWebsiteStatus = async (
  accountId: string,
  dynamicPageId: string,
  websiteId: string,
  status: 'active' | 'disabled',
): Promise<any> => {
  const websiteRef = doc(
    db,
    'accounts',
    accountId,
    'campaigns',
    dynamicPageId,
    'websites',
    websiteId,
  );

  return updateDoc(websiteRef, { status });
};

export const updateWebsite = async (
  accountId: string,
  dynamicPageId: string,
  websiteId: string,
  update: UpdateData<WebsiteData>,
): Promise<any> => {
  const websiteRef = doc(
    db,
    'accounts',
    accountId,
    'campaigns',
    dynamicPageId,
    'websites',
    websiteId,
  );

  return updateDoc(websiteRef, update);
};

export const aiFieldCompletion = async (
  accountId: string,
  dynamicPageId: string,
  variantId: string,
  websiteId: string,
  sectionId: string,
  fieldName: string,
  fieldContent: string,
  textSelection?: string | null,
  prompt?: string | null,
): Promise<any> => {
  const fn = httpsCallable(functions, 'accounts-websites-aiContentCompletion');

  const res = await fn({
    accountId,
    dynamicPageId,
    variantId,
    websiteId,
    sectionId,
    fieldName,
    fieldContent,
    textSelection,
    prompt,
  });

  console.log('aiFieldCompletion', res.data);

  return res.data;
};
